angular.module('client-feature')
    .factory('ClientFeature', function ($resource) {
        return $resource('/crm/api/client-feature/:id', {}, {
            list: {method: 'GET', isArray: false},
            update: {method: 'PUT'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/client-feature/autocomplete'}
        })
    })
